/** @format */

import $ from "jquery";
import axios from "axios";
import { Input } from "antd";
import { useReactToPrint } from "react-to-print";
import { SearchOutlined } from "@ant-design/icons";
import React, { useEffect, useState, useRef } from "react";
import { ExcelPrint, Pdf } from "../../../../components/functions/Print";

import { NavLink } from "react-router-dom";
import pdf from "../../../../icons/pdf.png";
import excel from "../../../../icons/excel.png";
import print from "../../../../icons/print.png";
import { header } from "../../../../components/api/Header";
import LoadingCard from "../../../../components/loading/loadingCard";
import { getEnv } from "../../../../lib/env";
import { formatReservoirName } from "./helpers";

const TABLE_TITLE =
  "Respublika va respublikalararo suv omborlari ishlashi to'g'risida ma'lumot";

const normalizeReservoirSortName = (value) =>
  formatReservoirName(value)
    .toLowerCase()
    .replace(/[`'’‘ʻʼ]/g, "")
    .replace(/[^a-z0-9а-яёҳқғў]+/gi, "");

const isTuyamoyinReservoir = (row) =>
  normalizeReservoirSortName(row?.nomi).includes("tuyamoyin");

const isSmallReservoirsRow = (row) => {
  const name = normalizeReservoirSortName(row?.nomi);
  return (
    name.includes("kichiksuvombvaboshqalar") ||
    name.includes("kichiksuvomborlar")
  );
};

const isArnasoyReservoir = (row) =>
  normalizeReservoirSortName(row?.nomi).includes("arnasoy");

const shouldAddToRepublicTotal = (
  row,
  index,
  shuJumladanAfterIndex,
  firstTotalIndex
) =>
  index <= firstTotalIndex &&
  (index <= shuJumladanAfterIndex ||
    isArnasoyReservoir(row) ||
    isSmallReservoirsRow(row));

function Table2({ date, setOmbor, setLoading, loading }) {
  const conponentPDF = useRef();
  const [data, setData] = useState([]);
  const tuyamoyinIndex = data.findIndex(isTuyamoyinReservoir);
  const smallReservoirIndex = data.findIndex(isSmallReservoirsRow);
  const shuJumladanAfterIndex = tuyamoyinIndex >= 0 ? tuyamoyinIndex : 25;
  const firstTotalIndex = smallReservoirIndex >= 0 ? smallReservoirIndex : 30;
  const secondTotalIndex = smallReservoirIndex >= 0 ? smallReservoirIndex + 4 : 35;

  let searchTimeout;
  let sums1 = Array(6).fill(null);
  let sums2 = Array(6).fill(null);

  const setSearch = (text) => {
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(() => {
      $("tbody tr.data-tr").each(function () {
        if (
          $(this)
            .children(".fix-with")[0]
            .innerText.toUpperCase()
            .indexOf(text.toUpperCase()) > -1
        ) {
          $(this)[0].style.display = "";
        } else {
          $(this)[0].style.display = "none";
        }
      });
      if (text !== "") {
        $("tbody tr.j-tr").css("display", "none");
      } else {
        $("tbody tr.j-tr").css("display", "");
      }
    }, 500);
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          getEnv('REACT_APP_BASE_URL') +
            "/v1/republik/suvombor/table2?date=" +
            date,
          header()
        );

        if (res) {
          setData(res.data);
        }
      } catch (e) {
        console.log("Xato", e);
        alert("Bazaga bog'lanishda xato");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [date]);

  const generatePDF = useReactToPrint({
    content: () => conponentPDF.current,
    documentTitle: "Userdata",
    onAfterPrint: () => alert("Data saved in PDF"),
  });

  return (
    <>
      <div className='table-content-top'>
        <div className='table-top-left'>
          <Input
            prefix={<SearchOutlined className='site-form-item-icon' />}
            placeholder='Search'
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <ul className='table-top-right'>
          <li>
            <button className='btn p-0' onClick={() => generatePDF()}>
              <img src={print} alt='404' />
            </button>
          </li>
          <li>
            <button onClick={() => Pdf("so2", true, date)} className='btn p-0'>
              <img src={pdf} alt='404' />
            </button>
          </li>
          <li>
            <button
              className='btn p-0'
              onClick={() =>
                ExcelPrint("MChS", "Sheet 1", "so2", date)
              }>
              <img src={excel} alt='404' />
            </button>
          </li>
        </ul>
      </div>

      {loading ? (
        <LoadingCard loading={loading} heightSize='80vh' />
      ) : (
        <div className='table-responsive tableFixHead' id='tableFlexible'>
          <div ref={conponentPDF} style={{ width: "100%" }}>
            <table
              className='table table-bordered table-style suv-reservoir-table'
              id='so2'>
              <thead>
                <tr>
                  <th colSpan={8} scope='col'>
                    {TABLE_TITLE}
                  </th>
                </tr>

                <tr>
                  <th rowSpan={3} scope='col'>
                    N
                  </th>

                  <th rowSpan={3} scope='col'>
                    Suv omborlar nomi
                  </th>

                  <th colSpan={4} scope='col'>
                    Hajmi (mln.m<sup>3</sup>)
                  </th>

                  <th rowSpan={2} scope='col'>
                    Kelishi, m<sup>3</sup>/sek
                  </th>

                  <th rowSpan={2} scope='col'>
                    Chiqishi, m<sup>3</sup>/sek
                  </th>
                </tr>

                <tr>
                  <th rowSpan={2} scope='col'>
                    Loyiha bo’yicha
                  </th>

                  <th rowSpan={2} scope='col'>
                    Ishlatib bo’lmaydi
                  </th>

                  <th colSpan={2} scope='col'>
                    Amalda
                  </th>
                </tr>

                <tr>
                  <th scope='col'>
                    {parseInt(date.slice(0, 4)) - 1}-{date.slice(5 - 10)}
                  </th>
                  <th scope='col'>{date}</th>
                  <th scope='col'>{date}</th>
                  <th scope='col'>{date}</th>
                </tr>
              </thead>

              <tbody>
                <tr className='table-one-row'>
                  <td colSpan={8}>Respublika</td>
                </tr>
              </tbody>

              {data.length > 0
                ? data.map((d, index) => {
                    if (index === 0) {
                      sums1 = Array(6).fill(null);
                      sums2 = Array(6).fill(null);
                    }

                    if (
                      shouldAddToRepublicTotal(
                        d,
                        index,
                        shuJumladanAfterIndex,
                        firstTotalIndex
                      )
                    ) {
                      sums1[0] = qosh(sums1[0], d.loyiha_boyicha);

                      sums1[1] = qosh(sums1[1], d.yaroqsiz);

                      sums1[2] = qosh(sums1[2], d.data1);

                      sums1[3] = qosh(sums1[3], d.data2);

                      sums1[4] = qosh(sums1[4], d.data3);

                      sums1[5] = qosh(sums1[5], d.data4);
                    }

                    if (index > firstTotalIndex) {
                      sums2[0] = qosh(sums2[0], d.loyiha_boyicha);

                      sums2[1] = qosh(sums2[1], d.yaroqsiz);

                      sums2[2] = qosh(sums2[2], d.data1);

                      sums2[3] = qosh(sums2[3], d.data2);

                      sums2[4] = qosh(sums2[4], d.data3);

                      sums2[5] = qosh(sums2[5], d.data4);
                    }

                    return (
                      <tbody key={index}>
                        <tr className='data-tr'>
                          <td>{index + 1}</td>

                          <td className='text-start fix-with'>
                            <NavLink
                              style={{
                                color: "#222",
                              }}
                              to={"/suvomborlari/" + d.id}
                              onClick={() =>
                                setOmbor({
                                  nomi: d.nomi,
                                  location: [d.lat, d.lan],
                                })
                              }>
                              {formatReservoirName(d.nomi)}
                            </NavLink>
                          </td>

                          <td>{filteredValue(d.loyiha_boyicha)}</td>

                          <td>{filteredValue(d.yaroqsiz)}</td>

                          <td>{filteredValue(d.data1)}</td>

                          <td>{filteredValue(d.data2)}</td>

                          <td>{filteredValue(d.data3)}</td>

                          <td>{filteredValue(d.data4)}</td>
                        </tr>

                        {index === shuJumladanAfterIndex ? (
                          <tr className='j-tr'>
                            <td></td>
                            <td>shu jumladan</td>
                            {Array.from({ length: 6 }).map((_, cellIndex) => (
                              <td key={cellIndex}></td>
                            ))}
                          </tr>
                        ) : null}

                        {index === firstTotalIndex ? (
                          <>
                            <tr className='j-tr'>
                              <td colSpan={2}>Jami</td>

                              {sums1.map((s, i) => {
                                return <td key={i}>{filteredValue(s)}</td>;
                              })}
                            </tr>

                            <tr className='table-one-row j-tr'>
                              <td colSpan={8}>Respublikalararo</td>
                            </tr>
                          </>
                        ) : null}

                        {index === secondTotalIndex ? (
                          <>
                            <tr className='j-tr'>
                              <td colSpan={2}>Jami</td>

                              {sums2.map((s, i) => {
                                return <td key={i}>{filteredValue(s)}</td>;
                              })}
                            </tr>

                            <tr className='j-tr'>
                              <td colSpan={2}>Hammasi</td>

                              {mergeSums(sums1, sums2).map((s, i) => {
                                return <td key={i}>{filteredValue(s)}</td>;
                              })}
                            </tr>
                          </>
                        ) : null}
                      </tbody>
                    );
                  })
                : null}
            </table>
          </div>
        </div>
      )}
    </>
  );
}

export default Table2;

const qosh = (a, b) => {
  if (!hasNumericValue(b)) {
    return hasNumericValue(a) ? a : null;
  }

  const base = hasNumericValue(a) ? parseFloat(a) : 0;
  const s = base + parseFloat(b);

  if (isNaN(s)) return;

  return s;
};

const mergeSums = (first, second) =>
  first.map((value, index) => qosh(value, second[index]));

const hasNumericValue = (value) => {
  if (
    value === null ||
    value === undefined ||
    value === "" ||
    value === "undefined"
  ) {
    return false;
  }

  return !isNaN(parseFloat(value));
};

const filteredValue = (a) => {
  if (a === null || a === undefined || a === "" || a === "undefined") {
    return "-";
  }

  const n = parseFloat(a);
  if (isNaN(n)) return "-";

  const rounded = Math.round((n + Number.EPSILON) * 10) / 10;

  return rounded % 1 === 0 ? Math.floor(rounded) : rounded;
};
